import { IconProps, iconA11yProps } from '../types';

export const HighFive = ({ classNames, label }: IconProps) => (
    <svg className={`relative ${classNames}`} id="icon-highfive" width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...iconA11yProps(label)}>
        <g clipPath="url(#clip)">
            <rect x="1.5" y="1.5" width="93" height="93" rx="14.5" strokeWidth="3" />
            <g id="hand-back-wrapper" className="animate-handBackIn">
                <g id="hand-back" className="animate-clapBack">
                    <path d="M64.5 57V38C64.5 35.7909 66.2909 34 68.5 34C70.7091 34 72.5 35.7909 72.5 38V39" strokeWidth="3" strokeLinecap="round" />
                    <path d="M70.5 58V43C70.5 40.7909 72.2909 39 74.5 39C76.7091 39 78.5 40.7909 78.5 43V55" strokeWidth="3" strokeLinecap="round" />
                    <path
                        d="M58.5 59V42C58.5 39.7909 60.2909 38 62.5 38C63.2286 38 63.9117 38.1948 64.5 38.5351"
                        strokeWidth="3"
                        strokeLinecap="round"
                    />
                    <path
                        d="M58.5 45.5351C57.9117 45.1948 57.2286 45 56.5 45C54.2909 45 52.5 46.7909 52.5 49V74C52.5 78.9706 56.5294 83 61.5 83C61.8457 83 62.1794 82.992 62.5 82.9773"
                        strokeWidth="3"
                        strokeLinecap="round"
                    />
                    <path
                        d="M75.5 68.5V59.5C75.5 57.0147 77.5147 55 80 55C82.4853 55 84.5 57.0147 84.5 59.5V74C84.5 78.9706 80.4706 83 75.5 83C70.5 83 68.5 80 68 79.5"
                        strokeWidth="3"
                        strokeLinecap="round"
                    />
                    <path
                        d="M76.5 83C77.5 95 85.5 105 94.5 110.5C86.5 110.5 75.8333 110.833 72 111C66 105.5 61 96.5 61 83"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
            </g>
            <g id="hand-front-wrapper" className="animate-handFrontIn">
                <g id="hand-front" className="animate-clapFront">
                    <path
                        d="M17.5 44C15.2909 44 13.5 45.7909 13.5 48V73C13.5 77.4595 16.7434 81.1614 21 81.8756C21 92.8756 12 104.5 3 110C11 110 21.6667 110.333 25.5 110.5C31.5 105 36.5 96 36.5 82.5C41.4706 82.5 45.5 78.4706 45.5 73.5V59C45.5 56.5147 43.4853 54.5 41 54.5C40.474 54.5 39.9692 54.5902 39.5 54.7561V42C39.5 39.7909 37.7091 38 35.5 38C34.7714 38 34.0883 38.1948 33.5 38.5351V37C33.5 34.7909 31.7091 33 29.5 33C27.2909 33 25.5 34.7909 25.5 37V37.5351C24.9117 37.1948 24.2286 37 23.5 37C21.2909 37 19.5 38.7909 19.5 41V44.5351C18.9117 44.1948 18.2286 44 17.5 44Z"
                        className="fill-current"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path d="M19.5 44.5352V57" strokeWidth="3" />
                    <path d="M25.5 37.5352V56" strokeWidth="3" />
                    <path d="M31.5 57V42C31.5 40.5195 32.3044 39.2268 33.5 38.5352" strokeWidth="3" strokeLinecap="round" />
                    <path d="M36.5 65.9998V58.9998C36.5 57.0405 37.7522 55.3736 39.5 54.7559" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                </g>
            </g>
            <path className="animate-clapLine" d="M31.9043 14.9038L41.0967 24.0962" strokeWidth="3" strokeLinecap="round" strokeDasharray="18 14" />
            <path className="animate-clapLine" d="M47.5 8V21" strokeWidth="3" strokeLinecap="round" strokeDasharray="18 14" />
            <path className="animate-clapLine" d="M63.0957 14.9038L53.9033 24.0962" strokeWidth="3" strokeLinecap="round" strokeDasharray="18 14" />
        </g>
        <defs>
            <clipPath id="clip">
                <rect width="96" height="96" rx="16" fill="#FF0000" />
            </clipPath>
        </defs>
    </svg>
);
